module.exports = __webpack_public_path__ + "media/images/app/theme-2bf6c1fb240ff57fe6ad238556d1f492.svg";